export default "/images/23360f3703f8e84a2ea1433e3ffbad04.avif";